import { render } from "./addWe.vue?vue&type=template&id=945184ea&scoped=true"
import script from "./addWe.vue?vue&type=script&lang=js"
export * from "./addWe.vue?vue&type=script&lang=js"

import "./addWe.vue?vue&type=style&index=0&id=945184ea&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-945184ea"]])

export default __exports__